var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Location } from '../locations/location';
export class WorkplacePreferences {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], WorkplacePreferences.prototype, "isRemote", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], WorkplacePreferences.prototype, "isPartiallyRemote", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], WorkplacePreferences.prototype, "isFaceToFace", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], WorkplacePreferences.prototype, "isAnywhere", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => Location),
    __metadata("design:type", Array)
], WorkplacePreferences.prototype, "desiredLocations", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], WorkplacePreferences.prototype, "comments", void 0);
export class WorkplacePreferencesUpdate {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], WorkplacePreferencesUpdate.prototype, "isRemote", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], WorkplacePreferencesUpdate.prototype, "isPartiallyRemote", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], WorkplacePreferencesUpdate.prototype, "isFaceToFace", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], WorkplacePreferencesUpdate.prototype, "isAnywhere", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], WorkplacePreferencesUpdate.prototype, "desiredLocations", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], WorkplacePreferencesUpdate.prototype, "comments", void 0);
//# sourceMappingURL=workplace-preferences.js.map